module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stage-bar"
  }, [_c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return (tag.top) ? _c('div', {
      staticClass: "tag top",
      style: ({
        left: _vm.get_percent_tag(tag) + "%"
      })
    }, [_vm._v(_vm._s(tag.top))]) : _vm._e()
  })), _c('div', {
    staticClass: "ui progress active",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "bar",
    class: _vm.barClass,
    staticStyle: {
      "transition-duration": "300ms"
    },
    style: ({
      width: _vm.computed_percent + "%",
      background: _vm.color
    })
  }, [(_vm.showProgress) ? _c('div', {
    staticClass: "progress"
  }, [_vm._v(_vm._s(_vm.computed_percent) + "%")]) : _vm._e()]), _c('div', {
    staticClass: "indicators"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      staticClass: "indicator",
      class: {
        top: tag.top, bottom: tag.bottom
      },
      style: ({
        left: _vm.get_percent_tag(tag) + "%"
      })
    })
  })), (_vm.label) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return (tag.bottom) ? _c('div', {
      staticClass: "tag bottom",
      style: ({
        left: _vm.get_percent_tag(tag) + "%"
      })
    }, [_vm._v(_vm._s(tag.bottom))]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4c6a4a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/StageBar.vue
// module id = 307
// module chunks = 0